import React from 'react';

import { ContentfulInfoBars } from 'ContentfulWrappers/ContentfulInfoBars';
import { useTextContext } from 'Contexts/textContext';
import InfoBar from 'DesignLibrary/molecules/InfoBar';
import { InvalidPlanMessageKey } from 'Types/entities';

export interface InvalidPlanMessageProps {
  invalidPlanMessageKey: InvalidPlanMessageKey | null;
}

const InvalidPlanSelectionMessage = ({ invalidPlanMessageKey }: InvalidPlanMessageProps) => {
  const { retrieveContentfulData } = useTextContext();

  const messageText = retrieveContentfulData<string>(
    `health_section.recommendation.invalidate_plan_message.${invalidPlanMessageKey}`,
  );

  return (
    <ContentfulInfoBars sectionKey="health_section">
      <div key={invalidPlanMessageKey}>
        <InfoBar
          data-testid="plan-invalidate"
          className="custom-disclaimer"
          color="yellow"
          text={messageText}
          icon="Warning"
          inline={false}
        />
      </div>
    </ContentfulInfoBars>
  );
};

export default InvalidPlanSelectionMessage;
